// @ts-expect-error
import type {RouterHistory} from 'react-router-dom';

import type {User} from 'nutshell-core/users/users-types';

import type {Lead} from 'nutshell-graphql-types';

import {SalesDocumentsWidgetWrapper} from '../deprecated/sales-documents-widget/sales-documents-widget-wrapper';
import {CustomFieldsWidgetOld} from '../deprecated/sidebar/custom-fields-widget-old';
import {AccountsAndContactsWidgetWrapper} from '../sidebar/accounts-and-contacts-widget';
import {CompetitorsWidgetWrapper} from '../sidebar/competitors-widget/competitors-widget-wrapper';
import {ProductWidgetWrapper} from '../sidebar/product-widget/product-widget-wrapper';
import {SourcesWidgetWrapper} from '../sidebar/source-widget/sources-widget-wrapper';

import styles from '../sidebar/sidebar.module.css';

type Props = {
    lead: Lead;
    stagesetId: string | null | undefined;
    history: RouterHistory;
    sidebarCustomFields: HTMLElement | null | undefined;
    sidebarCustomFieldsCount: number;
    onRenderSidebarCustomFields: () => void;
    user: User;
};

export function SidebarM1(props: Props) {
    return (
        <div className={styles.sidebar}>
            <AccountsAndContactsWidgetWrapper leadId={props.lead.id} />
            <ProductWidgetWrapper leadId={props.lead.id} />
            {props.user.permissions.canUseSalesDocuments && (
                <SalesDocumentsWidgetWrapper leadId={props.lead.id} />
            )}
            <CompetitorsWidgetWrapper leadId={props.lead.id} />
            <SourcesWidgetWrapper leadId={props.lead.id} user={props.user} />
            <CustomFieldsWidgetOld
                history={props.history}
                stagesetId={props.stagesetId}
                sidebarCustomFields={props.sidebarCustomFields}
                sidebarCustomFieldsCount={props.sidebarCustomFieldsCount}
                onRenderLeadMarkup={props.onRenderSidebarCustomFields}
                user={props.user}
            />
        </div>
    );
}
